import React from "react";

import workPassportRenewalSchedulerTrainingCohortTimelineDesktop from "../../images/work-passport-renewal-scheduler-training-cohort-timeline-desktop.svg";
import workPassportRenewalSchedulerTrainingCohortTimelineMobile from "../../images/work-passport-renewal-scheduler-training-cohort-timeline-mobile.svg";

import "./WorkPassportRenewalScheduler.css";

const WORK_PASSPORT_SCHEDULER_OUTCOMES = [
  "Less manual scheduling",
  "Lower operational downtime",
  "Earlier compliance action",
];

export default function WorkPassportRenewalScheduler() {
  return (
    <section
      className="work-passport-renewal-scheduler"
      id="work-passport-renewal-scheduler"
      aria-labelledby="work-passport-renewal-scheduler-title"
    >
      <div className="work-passport-renewal-scheduler__inner">
        <header className="work-passport-renewal-scheduler__header">
          <p className="work-passport-renewal-scheduler__eyebrow">
            <span aria-hidden="true" />
            Proactive compliance planning
          </p>
          <div className="work-passport-renewal-scheduler__heading-grid">
            <h2 id="work-passport-renewal-scheduler-title">
              Resolve the gap before it becomes downtime.
            </h2>
            <p>
              Work Passport forecasts upcoming expiries, groups affected
              employees and proposes efficient training windows before
              deployment readiness is interrupted.
            </p>
          </div>
        </header>

        <picture className="work-passport-renewal-scheduler__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportRenewalSchedulerTrainingCohortTimelineMobile}
          />
          <img
            src={workPassportRenewalSchedulerTrainingCohortTimelineDesktop}
            alt="Illustrative First Aid renewal timeline grouping fourteen employees from three sites into one recommended cohort"
          />
        </picture>

        <ul className="work-passport-renewal-scheduler__outcomes">
          {WORK_PASSPORT_SCHEDULER_OUTCOMES.map((outcome) => (
            <li key={outcome}><i aria-hidden="true" />{outcome}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
